import React from 'react'

import { PALETTE } from "../ThemeConstants";

export default function PremiumTag({ text = "Premium", background = PALETTE.LINEARGRADIENT, color = PALETTE.WHITE }) {
    return (
        <span
            className="px-1 py-1"
            style={{
                fontSize: 8,
                background: PALETTE.LINEARGRADIENT,
                borderTopLeftRadius: 10,
                borderBottomRightRadius: 10,
                color: PALETTE.WHITE
            }}>{text}</span>
    )
}